import React from "react";
import { Grid, Section, BreadCrumbBox } from "../../core";
import ReturnHistory from "../../components/ClothReturnHistory";
import { useDispatch } from "react-redux";
import { updateCurrentPath } from "../../redux/Action/pageRoot";

const ClothReturnHistoryPage = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(updateCurrentPath("Return History"));
  }, [dispatch]);

  return (
    <Grid>
      <BreadCrumbBox tittle="Return History" route="/contract-list" />
      <Section>
        <Grid>
          <ReturnHistory />
        </Grid>
      </Section>
    </Grid>
  );
};

export default ClothReturnHistoryPage;
